import { Skeleton } from '../../../../../Skeleton'
import { APPLICANT_CREDIT_CHECK_SKELETON_ROWS } from '../ApplicantCreditCheckBlock.constants'

import * as styles from '../ApplicantCreditCheckBlock.module.css'

function ApplicantCreditCheckSkeleton() {
  return (
    <div className={styles.skeleton}>
      <Skeleton className={styles.skeletonTitle} />
      {Array.from({ length: APPLICANT_CREDIT_CHECK_SKELETON_ROWS }).map(
        (_, index) => (
          <Skeleton className={styles.skeletonLine} key={index} />
        )
      )}
    </div>
  )
}

export default ApplicantCreditCheckSkeleton
